import Location16 from '@carbon/icons-react/es/location/16';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { queueMacrotask } from 'utils/macrotask';

export const TaskScrollIntoView: FC<{
  activeEditor: Editor;
  scrollId: number;
}> = ({ activeEditor, scrollId }) => {
  const scrollToTheRef = useTranslation('document.tasks.scroll_to_the_ref');

  const scrollIntoView = (activeTaskId: number) => {
    queueMacrotask(() => {
      document
        .querySelector(`.ck [data-taskid="rl-task-${activeTaskId}"]`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  return (
    <Tooltip title={scrollToTheRef}>
      <Button
        type="link"
        icon={<Location16 />}
        size="small"
        onClick={() => {
          const options = {
            taskId: `rl-task-${scrollId}`,
          };

          scrollIntoView(scrollId);
          activeEditor.execute('activeTaskCommand', options);
        }}
      />
    </Tooltip>
  );
};
